export function InitialState() {
    return {
        fetchFollowUpQuestionReportApi: {
            isProcessing: false,
            data: null,
            error: false,
            message: "",
        },
    };
}